export enum DataRequestLevel {
  platform = 'platform',
  tenant = 'tenant',
  organization = 'organization',
  none = 'none',
}
